export const QueryModelValidatorMessages = {
    METRICS_MISSED: 'metric "{name}" are not longer exist in dataset schema',
    DIMENSIONS_MISSED: 'dimension "{name}" are not longer exist in dataset schema',
    VARIABLES_MISSED: 'variable "{name}" are not longer exist in dataset schema',
    DRILLDOWN_DIMENSIONS_MISSED: 'drilldown "{name}" dimensions "{dimensions}" are not longer exist in dataset schema',

    QUERY_DIMENSION_MISSED: 'dimension "{name}" are not longer exist in query',
    DRILLDOWN_MISSED_QUERY_DIMENSIONS: `drilldown "{name}" have dimensions "{dimensions}" that did not exist in query dimensions`,
    DRILLDOWN_CONFLICTING_QUERY_PARAM: `drilldown "{name}" is equal to metrics or dimensions`,
    SORT_MISSED_QUERY_PARAM: `sort "{name}" use dimensions or metrics that did not exist in query`,
    FILTER_MISSED_QUERY_PARAM: `filter "{name}" use dimensions, metrics or fields that did not exist in query`,
};

export const DatasetEditorMessages = {
    DATASET_NOT_FOUND_IN_DATA_PROVIDER: 'dataset not found in current data provider',
    DATASET_DATAPROVIDER_NOT_EXISTS_IN_PROJECT: 'specified dataset dataprovider does not exist in current project',
}

export const Messages = {
    ...QueryModelValidatorMessages,
    ...DatasetEditorMessages
};